module.exports = __webpack_public_path__ + "static/media/alloy-castings.7ecaf4ee.jpg";